module.exports = __webpack_public_path__ + "static/media/BeaconLogo-april-2025.0a9c30e9.png";